module.exports = __webpack_public_path__ + "static/media/20210109_211018_236_IMG_1713.db437e2b.jpg";